<template>
  <div class="body-container">
    <div :id="id" :style="{ minHeight: `${height}px`, height: `${height}px`, width: `${resolveWidth}` }"></div>
    <div class="order-1 justify-content-end pagination">
      <Pagination
        v-if="true"
        v-model="paginationModel"
        :totalRows="props.pagination.totalRows"
        :perPages="props.pagination.perPage"
        @update:modelValue="updatePagination"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EChartsOption } from 'echarts';

import { ref, defineEmits, onBeforeMount, getCurrentInstance } from 'vue';

import useBarStackPaginationChart from './hooks/useBarStackPaginationChart';
import Pagination from '@/views/components/pagination/Pagination.vue';
import { onMounted } from 'vue';

interface Props {
  rawData?: Charts.ChartsProps.RawData;
  colorList: Charts.ChartsProps.ColorItem[];
  options?: EChartsOption;
  height?: number | string;
  width?: number | string;
  responsiveWidth?: boolean;
  responsiveHeight?: boolean;
  eventType?: string;
  function?: Function;
  pagination: BaseTable.Pagination;
}

const props = withDefaults(defineProps<Props>(), {
  options: undefined,
  height: 200,
  width: 300,
  responsiveWidth: false,
  responsiveHeight: false,
  eventType: 'dbClick' || '',
  function: () => {},
});

const vm = getCurrentInstance()?.proxy;

const paginationModel = ref(props.pagination.currentPage);

const { id, resolveHeight, resolveWidth } = useBarStackPaginationChart(props);

const updatePagination = (page: number) => {
  vm?.$emit('on-page-change', page);
};
</script>

<style lang="scss" scoped>
.body-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .pagination {
    padding-right: 12.5rem;
  }
}
</style>
